import { TagColorSchemes } from '@paywithextend/components'
import cn from 'classnames'
import { blue400 } from 'ext-ui/style/colors'
import React from 'react'
import { useSelector } from 'react-redux'
import { BrandMarkLogoIcon } from 'src/components/BrandMarkLogoIcon/BrandMarkLogoIcon'
import BrandPrimaryLogo from 'src/components/BrandPrimaryLogo/BrandPrimaryLogo'
import SidenavContentNavItem from 'src/components/SidenavContentNavItem/SidenavContentNavItem'
import SvgGreyExtendSparkle from 'src/components/Svgs/SvgGreyExtendSparkle'
import SvgSidenavHelpCenterActive from 'src/components/Svgs/SvgSidenavHelpCenterActive'
import SvgSidenavHelpCenterInactive from 'src/components/Svgs/SvgSidenavHelpCenterInactive'
import SvgSidenavSettings from 'src/components/Svgs/SvgSidenavSettings'
import Tag from 'src/components/Tag/Tag'
import { useTranslate } from 'src/localization/Trns'
import { manageSubscriptionUrl, organizationInfoUrl } from 'src/navigation/urls'
import { useQueryOwnUser } from 'src/queries/users.queries'
import { selectFeatureFlaggerFromState } from 'src/redux/selectors/data/featureFlagger.selectors'
import { Userpilot } from 'userpilot'

import * as styles from './SidenavBottomContent.style'

export interface SidenavBottomContentProps {
  tierLabel?: string
  isSidenavOpen: boolean
  showUpgradePlan?: boolean
  onShowSettings: () => void
}

const SidenavBottomContent: React.FC<SidenavBottomContentProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()
  const { data: user } = useQueryOwnUser({})

  const { show_new_org_settings: showNewOrgSettings } = useSelector(
    selectFeatureFlaggerFromState,
  )

  return (
    <div css={styles.sidenavBottomContainer}>
      <SidenavContentNavItem
        isSidenavOpen={props.isSidenavOpen}
        id={'mainNavSettings'}
        isActive={false}
        onClick={props.onShowSettings}
        ActiveSvg={<SvgSidenavSettings fill={blue400} stroke={blue400} />}
        InactiveSvg={<SvgSidenavSettings />}
        label={translate('Settings')}
      />
      <SidenavContentNavItem
        isSidenavOpen={props.isSidenavOpen}
        id={'mainNavHelpAndSupport'}
        isActive={false}
        onClick={(): void => {
          Userpilot.trigger('resource_center:jNfDAOvnub')
        }}
        ActiveSvg={<SvgSidenavHelpCenterActive />}
        InactiveSvg={<SvgSidenavHelpCenterInactive />}
        label={translate('Help & Support')}
      />
      {props.showUpgradePlan && (
        <SidenavContentNavItem
          isSidenavOpen={props.isSidenavOpen}
          id={'mainNavUpgradePlan'}
          isActive={false}
          ActiveSvg={<SvgGreyExtendSparkle />}
          InactiveSvg={<SvgGreyExtendSparkle />}
          to={
            showNewOrgSettings
              ? manageSubscriptionUrl(user?.organizationId || '')
              : organizationInfoUrl(user?.organizationId || '')
          }
          label={translate('Upgrade Plan')}
        />
      )}
      <div
        css={styles.sidenavLogoContainer}
        className={cn({
          open: props.isSidenavOpen,
          closed: !props.isSidenavOpen,
        })}
      >
        <div css={styles.sidenavLogoInner}>
          <div
            css={styles.sidenavBrandMarkContainer}
            className={cn({
              open: props.isSidenavOpen,
              closed: !props.isSidenavOpen,
            })}
          >
            <BrandMarkLogoIcon size={32} />
          </div>
          <div css={styles.sidenavBrandLogoContainer}>
            <BrandPrimaryLogo
              css={styles.sidenavBrandLogo}
              className={cn({
                open: props.isSidenavOpen,
                closed: !props.isSidenavOpen,
              })}
            />
            {props?.tierLabel && (
              <Tag
                color={TagColorSchemes.Blue}
                text={translate(props.tierLabel)}
                testId={`tier-${props.tierLabel.toLowerCase()}`}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SidenavBottomContent
